<template>
<div >
    
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="#6D0606"
      flat
      light
      height="27%"
      
      style="padding-top:25px;"
    >
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4 ml-12"
      >
      <v-img
        class="z-index: 10; mt-0"
        src="https://s3.amazonaws.com/circle.rubies.ng/assets/img/new-rubies-logo-full.png"
        lazy-src="https://s3.amazonaws.com/circle.rubies.ng/assets/img/new-rubies-logo-full.png"
        aspect-ratio="1"
        max-width="200"
        max-height="70"

        ></v-img>
      </v-toolbar-title>
    </v-app-bar>
</div>
</template>
<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      dialog: false,
      drawer: null,
      avatar: localStorage.avatar,
      groupname: localStorage.groupname,
      avartarItems: [
        { title: 'Profile' },
        { title: 'Settings' },
        { title: 'Logout' },
      ],
      items: [
        { icon: 'contacts', text: 'Contacts' },
        { icon: 'history', text: 'Frequently contacted' },
        { icon: 'content_copy', text: 'Duplicates' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Labels',
          model: true,
          children: [
            { icon: 'add', text: 'Create label' },
          ],
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'More',
          model: false,
          children: [
            { text: 'Import' },
            { text: 'Export' },
            { text: 'Print' },
            { text: 'Undo changes' },
            { text: 'Other contacts' },
          ],
        },
        { icon: 'settings', text: 'Settings' },
        { icon: 'chat_bubble', text: 'Send feedback' },
        { icon: 'help', text: 'Help' },
        { icon: 'phonelink', text: 'App downloads' },
        { icon: 'keyboard', text: 'Go to the old version' },
      ],
    }),
    mounted() {
        localStorage.drawer = false
    },
  }
</script>

